(function () {
    'use strict';

    // @ngInject
    Services.ReactFirstRolloutService = function ReactFirstRolloutService($log, StatsigService, $window, $q) {
        this.$log = $log;
        this.StatsigService = StatsigService;
        this.$window = $window;
        this.$q = $q;
    };
    angular.extend(Services.ReactFirstRolloutService.prototype, {
        checkAndRedirectIfNeeded: function checkAndRedirectIfNeeded() {
            var deferred = this.$q.defer();
            this.StatsigService.isGateEnabled('react-first-rollout', false).then(function(isEnabled) {
                var isInClientPortal = this.$window.isClientPortal();
                var isLinkResolver = this.$window.location.pathname.startsWith('/app/link/resolve')
                var isInIframe = this.$window.self !== this.$window.top;
                if (!isInIframe && isEnabled && !isInClientPortal && !isLinkResolver) {
                    var baseUrl = this.getNextAppBaseUrl();
                    var relativeUrl = this.$window.location.pathname + this.$window.location.search;
                    try {
                        this.$window.localStorage.setItem('rf-rollout-redirect-base-url', baseUrl);
                    } catch (error) {
                        this.$log.error('Failed to save react first rollout redirect base url to localStorage', {
                            error: error,
                            context: {
                                source: 'angular',
                                isInIframe: isInIframe,
                                isGateEnabled: isEnabled,
                                relativeUrl: relativeUrl,
                                isInClientPortal: isInClientPortal
                            }
                        });
                    } finally {
                        var sep = relativeUrl.indexOf('?') !== -1 ? '&amp;' : '?';
                        var redirectUrl = baseUrl + relativeUrl + sep + 'rf-rollout-redirect=true';
                        this.$window.location.href = redirectUrl;
                        deferred.resolve(true); // Redirect happened
                    }
                } else {
                    try {
                        this.$window.localStorage.removeItem('rf-rollout-redirect-base-url');
                    } catch (error) {
                        this.$log.error('Failed to clear react first rollout redirect base url from localStorage', {
                            error: error,
                            context: {
                                source: 'angular',
                                isInIframe: isInIframe,
                                isGateEnabled: isEnabled
                            }
                        });
                    }
                    deferred.resolve(false); // No redirect
                }
            }.bind(this)).catch(function(err) {
                this.$log.error('Failed to check react-first-rollout gate', err);
                try {
                    this.$window.localStorage.removeItem('rf-rollout-redirect-base-url');
                } catch (error) {
                    this.$log.error('Failed to clear react first rollout redirect base url from localStorage', error);
                }
                deferred.resolve(false); // No redirect on error
            }.bind(this));
            return deferred.promise;
        },

        getNextAppBaseUrl: function getNextAppBaseUrl() {
            var hostname = this.$window.location.hostname;
            var stgMatch = hostname.match(/hb-app-staging-([^.]+)\.web\.([^.]+)\.stg/);
            if (stgMatch) {
                return 'https://hb-mx-staging-' + stgMatch[1] + '.web.' + stgMatch[2] + '.stg-us-east-1-v7.hbdev.io';
            } else if (hostname === 'localhost') {
                return 'http://localhost:7100';
            } else if (hostname.indexOf('hbdev.io') !== -1) {
                return this.$window.location.origin.replace('hb-app-staging', 'hb-mx-staging');
            } else {
                return 'https://app.honeybook.com';
            }
        }
    });
}()); 